import { TableCard } from '../../../../components'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { RelatorioListHeader } from './components/header/RelatorioListHeader'
import { RelatorioTable } from './table/RelatorioTable'

const RelatorioList = () => {
  return (
    <TableCard>
      <RelatorioListHeader />
      <RelatorioTable />
    </TableCard>
  )
}

export const RelatorioListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <RelatorioList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
